<template>
  <div class="register">
    <v-stepper class="stepper" v-model="selectedStep" dark>
      <v-stepper-header>
        <v-stepper-step color="green" step="1">Persönliches</v-stepper-step>
        <v-divider></v-divider>

        <v-stepper-step color="green" step="2">Profilbild</v-stepper-step>
        <v-divider></v-divider>

        <v-stepper-step color="green" step="3">Trainerdaten</v-stepper-step>
        <v-divider></v-divider>

        <v-stepper-step color="green" step="4" complete>Status</v-stepper-step>
      </v-stepper-header>

      <v-stepper-items class="items">
        <v-stepper-content class="content" step="1">
          <h1>
            Damit wir passende Vereine für <span class="green-text">dich</span> finden
            können, benötigen wir noch einige wichtige Infos von dir.
          </h1>
          <hr class="green-line" />

          <label>
            Geburtsdatum
            <span>*</span>
          </label>
          <v-menu
            ref="menu"
            v-model="menu"
            locale="de"
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
            full-width
            color="green"
            min-width="290px"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                color="green"
                v-model="user_data.birthday"
                prepend-icon="event"
                readonly
                solo
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker
              color="green"
              ref="picker"
              locale="de"
              v-model="user_data.birthday"
              :max="new Date().toISOString().substr(0, 10)"
              min="1900-01-01"
            ></v-date-picker>
          </v-menu>

          <label>
            Geschlecht
            <span>*</span>
          </label>
          <v-select
            color="green"
            :items="sex"
            v-model="user_data.gender"
            solo
          ></v-select>

          <label> Nationalität <span>*</span> </label>
          <v-select
            v-model="user_data.nationality"
            :items="$store.state.nationalities"
            item-text="item_text"
            item-value="id"
            color="green"
            solo
          >
            <template v-slot:item="slotProps">
              <i
                :class="['mr-2', 'em', `em-flag-${slotProps.item.id.toLowerCase()}`]"
              ></i>
              {{ slotProps.item.item_text }}
            </template>
          </v-select>

          <label>Sprachen <span>*</span></label>
          <v-select
            solo
            v-model="user_data.languages"
            color="green"
            :items="$store.state.languages"
            chips
            multiple
          ></v-select>

          <label class="middle_header">Aktueller Wohnsitz <span>*</span></label>

          <!-- <label>Postleitzahl <span>*</span></label> -->
          <v-text-field
            color="green"
            v-model="user_data.zip_code"
            mask="#####"
            placeholder="Postleitzahl"
            solo
          ></v-text-field>

          <!-- <label>Ort, Bundesland</label> -->
          <v-text-field
            color="green"
            v-model="user_data.ort_bundesland"
            placeholder="Ort, Bundesland"
            solo
          ></v-text-field>

          <!-- <label>
            Wohnsitz (Land)
            <span>*</span>
          </label> -->
          <v-autocomplete
            color="green"
            :items="$store.state.countries.filter((c) => c === 'Deutschland')"
            v-model="user_data.place_of_living"
            placeholder="Land"
            disabled
            solo
          ></v-autocomplete>

          <v-btn
            color="green white--text"
            :disabled="
              !user_data.birthday ||
              !user_data.gender ||
              !(user_data.languages && user_data.languages.length) ||
              !user_data.nationality ||
              !user_data.place_of_living ||
              !user_data.zip_code ||
              !user_data.ort_bundesland
            "
            @click="next"
            >Weiter</v-btn
          >
        </v-stepper-content>

        <v-stepper-content class="content" step="2">
          <div v-if="user_data.big_thumbnail" class="upload-change-wrapper">
            <img
              class="register-avatar register-avatar__big"
              :src="user_data.big_thumbnail"
              alt=""
            />
            <label class="upload-label" for="upload-photo"
              ><b class="green-text">Profilbild</b> hochladen</label
            >
            <input
              class="upload-file-input"
              @change="croppie"
              type="file"
              accept="image/*"
              name="photo"
              id="upload-photo"
            />
          </div>
          <div v-else class="upload-wrapper">
            <label class="upload-label" for="upload-photo"
              ><b class="green-text">Profilbild</b> hochladen</label
            >
            <input
              class="upload-file-input"
              @change="croppie"
              type="file"
              accept="image/*"
              name="photo"
              id="upload-photo"
            />
          </div>

          <br />
          <v-btn color="white green--text" @click="back" text>Zurück</v-btn>
          <v-btn color="green white--text" :disabled="!imageSrc" @click="next"
            >Weiter</v-btn
          >
        </v-stepper-content>

        <v-stepper-content class="content" step="3">
          <label>
            Trainertyp
            <span>*</span>
          </label>
          <v-select
            color="green"
            :items="trainer_types"
            v-model="user_data.trainer_type"
            solo
          ></v-select>

          <label>Trainerlizenz <span>*</span></label>
          <v-select
            color="green"
            :items="license"
            v-model="user_data.license"
            solo
          ></v-select>

          <label v-if="user_data.license === 'Eigene Angabe'"
            >Eigene Angabe zur Lizenz</label
          >
          <v-text-field
            v-if="user_data.license === 'Eigene Angabe'"
            color="green"
            v-model="user_data.custom_license"
            solo
          ></v-text-field>

          <div>
            <label>
              Tätig seit
              <span>*</span>
            </label>
            <v-menu
              ref="since_menu"
              v-model="since_menu"
              locale="de"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              max-width="290px"
              min-width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  color="green"
                  v-model="formatSinceDate"
                  prepend-icon="event"
                  readonly
                  v-on="on"
                  solo
                ></v-text-field>
              </template>
              <v-date-picker
                color="green"
                locale="de"
                v-model="user_data.trainer_since"
                type="month"
                no-title
                scrollable
              >
                <v-spacer></v-spacer>
                <v-btn
                  text
                  min="1900-01-01"
                  :max="new Date().toISOString().substr(0, 10)"
                  color="green white--text"
                  @click="$refs.since_menu.save(user_data.trainer_since)"
                  >OK</v-btn
                >
              </v-date-picker>
            </v-menu>
          </div>

          <v-btn color="white green--text" @click="back" text>Zurück</v-btn>
          <v-btn
            color="green white--text"
            @click="next"
            :disabled="
              !user_data.trainer_type || !user_data.trainer_since || !user_data.license
            "
            >Weiter</v-btn
          >
        </v-stepper-content>

        <v-stepper-content class="content" step="4">
          <div style="display: inline-block">
            <v-switch
              color="green"
              v-model="user_data.no_team"
              :label="user_data.no_team ? 'Aktiver Trainer' : 'Vereinsloser Trainer'"
            ></v-switch>
          </div>
          <label>
            <span v-if="user_data.no_team">Aktueller</span>
            <span v-else>Letzter</span>
            Verein
            <span>*</span>
          </label>
          <v-text-field
            color="green"
            v-model="user_data.currentTeam"
            solo
          ></v-text-field>

          <label>
            Region/Verband
            <span>*</span>
          </label>
          <v-select
            color="green"
            :items="$store.state.verband"
            v-model="user_data.verband"
            solo
          ></v-select>
          <label v-if="user_data.verband">
            Liga
            <span>*</span>
          </label>
          <v-select
            v-if="user_data.verband"
            color="green"
            :items="$store.state.filter_leagues[user_data.verband]"
            item-text="league"
            item-value="category"
            return-object
            v-model="user_data.category"
            solo
          ></v-select>
          <v-btn color="white green--text" @click="back" text>Zurück</v-btn>
          <v-btn
            color="green white--text"
            :loading="loading"
            @click="updateData()"
            :disabled="
              !user_data.verband || !user_data.currentTeam || !user_data.category
            "
            >LET'S GO!</v-btn
          >
        </v-stepper-content>
      </v-stepper-items>
    </v-stepper>

    <CroppieDialog
      ref="croppieDialog"
      :image="imageSrc"
      :show.sync="showCroppie"
      @upload="cropRegistrationAvatar"
    />
  </div>
</template>

<script>
import moment from 'moment';
import { db } from '@/db';
import croppieMixin from '../../mixins/croppie';
import pushMixin from '../../mixins/push-notifications';
import registerMixin from '../../mixins/register';
import commonMixin from '../../mixins/common';
import CroppieDialog from '../../components/dialogs/CroppieDialog';

export default {
  name: 'register-trainer',
  watch: {
    menu(val) {
      val && setTimeout(() => (this.$refs.picker.activePicker = 'YEAR'));
    },
  },

  mixins: [croppieMixin, pushMixin, registerMixin, commonMixin],

  components: {
    CroppieDialog,
  },

  data: () => ({
    checkbox_anb: false,
    checkbox_datenschutz: false,
    menu: false,
    since_menu: false,
    loading: false,
    selectedStep: 1,
    date: new Date().toISOString().substr(0, 10),
    // settings: {
    //   no_team: true, // be carefull, before fix it was set to ja/nein, aber switch to true/false too, so its little wired how it works now > see: TrainerBio.vue
    // },
    trainer_types: [
      'Cheftrainer/in',
      'Co-Trainer/in',
      'Nachwuchstrainer/in',
      'Torwarttrainer/in',
      'Fitnesstrainer/in',
      'Athletiktrainer/in',
      'Mentaltrainer/in',
    ],
    license: [
      'Keine Lizenz',
      'Jugend-Elite-Lizenz',
      'C-Lizenz',
      'B-Lizenz',
      'A-Lizenz',
      'Fußballlehrer',
      'Eigene Angabe',
    ],
    email: '',
    password: '',
    picture: '',
    uploading: false,
    liga: [
      '1. Bundesliga',
      '2. Bundesliga',
      '3. Bundesliga',
      'Landesliga',
      'Kreisliga',
      'Regionalliga',
    ],
    items: ['Profi', 'Amateur', 'Halbprofi'],
    foot: ['Rechts', 'Links', 'Beide'],
    sex: ['Männlich', 'Weiblich'],
    showPW: false,
    rules: {
      required: (value) => !!value || '*Pflichtfeld.',
      min: (v) => v.length >= 8 || '*min. 8 Zeichen',
    },
  }),
  computed: {
    getNationality() {
      if (this.$store.state.user_data.nationality) {
        const found = this.$store.state.nationalities.find(
          (element) => element.id === this.$store.state.user_data.nationality,
        );
        return found.item_text;
      }
      return '-';
    },
    formatSinceDate() {
      return this.user_data.trainer_since
        ? moment(this.user_data.trainer_since).format('MM/YYYY')
        : '';
    },
  },
  methods: {
    next() {
      this.selectedStep++;
      this.$gtm.push({
        event: 'registration',
        registration_progress: `step ${this.selectedStep}`,
        registration_category: 'fullyRegisterTrainer',
      });
      window.scrollTo(0, 0);
    },
    back() {
      this.selectedStep--;
      this.$gtm.push({
        event: 'registration',
        registration_progress: `step ${this.selectedStep}`,
        registration_category: 'fullyRegisterTrainer',
      });
      window.scrollTo(0, 0);
    },

    updateData() {
      this.clearLinks();

      this.loading = true;

      const nationality = this.$store.state.nationalities.find(
        (n) => n.item_text === this.user_data.place_of_living,
      );
      this.user_data.search_nationality = nationality.id;
      this.user_data.fullyFilled = true;

      db.collection('trainers')
        .doc(this.user_data.id)
        .update({ ...this.user_data })
        .then(() => {
          this.$gtm.push({
            event: 'registration',
            registration_progress: 'success',
            registration_category: 'fullyRegisterTrainer',
          });
          this.$router.push({ name: 'trainer_home' });
        });
    },
  },

  beforeMount() {
    this.$gtm.push({
      event: 'registration_start',
      registration_progress: 'start',
      registration_category: 'fullyRegisterTrainer',
    });
  },

  mounted() {
    this.user_data.place_of_living = 'Deutschland';

    window.addEventListener('beforeunload', (e) => {
      // Cancel the event
      e.preventDefault();
      // Chrome requires returnValue to be set
      e.returnValue = '';
    });
  },
};
</script>

<style lang="scss">
@import '@/styles/register.scss';
</style>
